/**
 * @file index.jsx
 * @author Archana
 * @date 2024-10-03
 * @description ForgotPassword screen of the candidate
 */
import { Box, Typography, colors } from "@mui/material";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useFetchData } from "../../../components/hooks/useFetchData";
import { AuthCandidateBackground } from "../../../components/common/AuthCandidateBackground";
import { CandidateForgotPasswordForm } from "./CandidateForgotPasswordForm";
import { CrossroadsLogo } from "../../../assets/images/CrossroadsLogo";

const ForgotPassword = () => {
  const [successMsg, setSuccessMsg] = useState("");

  const { fetchData } = useFetchData();

  const onSignIn = async (data, setError) => {
    const { email } = data;
    const body = {
      email,
    };
    const result = await fetchData("candidateforgotpassword", {
      method: "post",
      body: body,
    });
    if (result?.code === 200) {
      setSuccessMsg(result.message);
    } else {
      setError("root", {
        type: "manual",
        message: result?.message || "Invalid credentials",
      });
      return;
    }
  };

  return (
    <Box
      position="relative"
      height="100vh"
      sx={{ "::-webkit-scrollbar": { display: "none" } }}
    >
      <AuthCandidateBackground />
      <Box
        sx={{
          position: "relative",
          left: 0,
          height: "100%",
          width: { xl: "30%", lg: "40%", md: "50%", xs: "100%" },
          transition: "all 1s ease-in-out",
          bgcolor: colors.common.white,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            opacity: 1,
            transition: "all 0.3s ease-in-out",
            height: "100%",
            "::-webkit-scrollbar": { display: "none" },
          }}
        >
          <Box
            sx={{
              textAlign: "center",
              p: 5,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CrossroadsLogo width="100%" height={100} />
          </Box>

          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              "::-webkit-scrollbar": { display: "none" },
            }}
          >
            <Box
              sx={{
                textAlign: "center",
                p: 5,
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Typography component="h1" variant="h5">
                Forgot Password
              </Typography>
            </Box>
            <CandidateForgotPasswordForm onSubmit={onSignIn} successMsg={successMsg} />

            <Typography variant="body2" mt={2}>
              Go back to{" "}
              <Link style={{ color: "#3A80F7", fontWeight: 600 }} to={"/candidate-login"}>
                Login
              </Link>
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default ForgotPassword;
